import { EPublishTermsAvailableMoneySources } from '../../../../../../types/reducers/publishTerms';
import { EMoneySource } from '../../../../../../types/reducers/user';

import { IMoneySourceTabProps } from '../../types';

export const getSources = (
  availableSources: EPublishTermsAvailableMoneySources,
  activeMoneySource: EMoneySource | null,
  cb: (v: EMoneySource) => void,
): IMoneySourceTabProps[] => {
  return [
    {
      disabled:
        availableSources !== EPublishTermsAvailableMoneySources.MasterAndSelf &&
        availableSources !== EPublishTermsAvailableMoneySources.Master,
      active: activeMoneySource === EMoneySource.Master,
      label: 'Со счёта агентства',
      handleClick: () => cb(EMoneySource.Master),
    },
    {
      disabled:
        availableSources !== EPublishTermsAvailableMoneySources.MasterAndSelf &&
        availableSources !== EPublishTermsAvailableMoneySources.Self,
      active: activeMoneySource === EMoneySource.Self,
      label: 'С личного счёта',
      handleClick: () => cb(EMoneySource.Self),
    },
  ];
};
